<template>
  <div>
    <div
      class="hero-section static-secondary d-flex flex-column align-center justify-center"
    >
      <h3 class="white--text font-weight-medium text-subtitle">FAQ</h3>
    </div>
    <faq></faq>
  </div>
</template>
<script>
import faq from "../../pages/dashboard/faq.vue";
export default {
  metaInfo: {
    title: "Focts FAQ - Your Ultimate Guide to Productivity Solutions",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      {
        name: "description",
        content:
          "Get answers with Focts FAQ. Uncover insights, troubleshoot, and optimize your experience. A comprehensive guide for seamless productivity. Your questions, answered!",
      },
      {
        name: "keywords",
        content:
          "Focts FAQ, Productivity Solutions, Ultimate Guide, Answers, Troubleshoot, Optimize Experience, Comprehensive, Seamless Productivity, Questions Answered, Get Insights, Explore Now, User Guide",
      },
    ],
  },
  components: {
    faq,
  },
};
</script>
<style scoped>
.hero-section {
  height: 500px;
}
</style>
